module.exports = __webpack_public_path__ + "img/_85C9093.0a824b50.jpeg";